import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {NavLink} from "react-router-dom";
import * as actions from "../actions";
import M from 'materialize-css';
import {Button, Icon} from "react-materialize";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {ADMIN, CUSTOMER, QA_USER, SUB_ADMIN, TEAM_LEAD, YT_HELPER, YT_HELPER_LEAD} from "../api/Constants";
import {isSidebarLinkAllowed} from "../constant/SidebarLinks";

import 'react-pro-sidebar/dist/css/styles.css';
import { ProSidebar, SidebarHeader, SidebarFooter, SidebarContent,Menu,MenuItem } from 'react-pro-sidebar';
import { AiOutlineCloudUpload, AiOutlineRobot, AiOutlineUserSwitch, AiOutlineYoutube, AiOutlineDashboard, AiOutlineSetting} from  'react-icons/ai';
import { HiOutlineUserGroup } from  'react-icons/hi';
import { RiArchiveDrawerLine } from  'react-icons/ri';
import { BiHomeAlt, BiStar, BiCard, BiMessageAlt, BiExport, BiListPlus } from 'react-icons/bi';
import { FiRepeat } from 'react-icons/fi';
import { FiSettings } from 'react-icons/fi';

export default connect(mapStateToProps, actions)((props) => {
    const auth = props.auth;
    const unSeenMessages = props.inboxSeenMessages?.unSeenCount;
    const subDomainData = props.subDomain.subDomainData;
    let parentId = localStorage.getItem('parentId');
    document.documentElement.style.setProperty('--theme--Color', subDomainData?.primary_color);
    document.documentElement.style.setProperty('--primary-text--Color', subDomainData?.primary_text_color);

    useEffect(() => {
        console.debug(M != null);
    }, []);

    const [toggled, setToggled] = useState(false);

    useEffect(() => {
        if (auth.loggedIn && !auth.loggedInUser && auth.loading === false) {
            props.fetchUser();
        }
        if (auth.loggedIn && !auth.loggedInUser){
            props.fetchAllWebsiteUsers();
            props.fetchWebsiteCardsCount();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [auth.loggedIn, auth.loggedInUser]);

    useEffect(() => {
        if(window.innerWidth<992)
        {
            setToggled(true);
            props.handleIsMobileView(true);
        }
        else
        {
            setToggled(false);
            props.handleIsMobileView(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [window.innerWidth])

    useEffect(() => {
        props.handleSidebarToggled(toggled)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [toggled]);

    /**
     * Drop links the parent-portal admin switched off for this role on this
     * white label site (website_type.sidebar_links_access). Each MenuItem's
     * key must match a key in constant/SidebarLinks.js.
     */
    function applySidebarAccess(links, clientType) {
        const access = subDomainData?.sidebar_links_access;
        return links.filter(item => item && isSidebarLinkAllowed(access, item.key, clientType));
    }

    function userTypeOptions(user) {
        if (parentId === '0') {
            return whiteLabelLink()
        } else {
            let clientType = (user && user.client_type) || '';
            let links;
            switch(clientType) {
                case ADMIN:
                case SUB_ADMIN:
                    links = adminHeaderLinks();
                    break;
                case TEAM_LEAD:
                case YT_HELPER_LEAD:
                    links = teamLeadHeaderLinks();
                    break;
                case QA_USER:
                case YT_HELPER:
                    links = qaHeaderLinks();
                    break;
                case CUSTOMER:
                    links = customerHeaderLinks();
                    break;
                default:
                    return '';
            }
            return applySidebarAccess(links, clientType);
        }
    }

    function whiteLabelLink() {
        return [
            <MenuItem key="whiteLabelCustomersNav" onClick={() => props.fetchAllWhiteLabelCustomers()}>
            <NavLink to="/whitelabelcustomers">
                <HiOutlineUserGroup/>&nbsp;&nbsp;White Label Customers
            </NavLink>
            </MenuItem>,
            <MenuItem key="settingsNav">
            <NavLink to="/settings">
                {/* <FontAwesomeIcon icon="cogs"/> */}
                <AiOutlineSetting/>&nbsp;&nbsp;Portal Settings
            </NavLink>
            </MenuItem>,
        ];
    }

    function adminHeaderLinks() {
        return [
            <MenuItem key="home">
                <NavLink to="/">
                    <BiHomeAlt/>&nbsp;&nbsp;Home
                </NavLink>
            </MenuItem>,
            <MenuItem key="upload">
            <NavLink to="/upload">
            <AiOutlineCloudUpload/>&nbsp;&nbsp;Upload
            </NavLink>
            </MenuItem>,
            <MenuItem key="users">
            <NavLink to="/users">
            <AiOutlineUserSwitch/>&nbsp;&nbsp;Users
            </NavLink>
            </MenuItem>,
            <MenuItem key="customers">
            <NavLink to="/customers">
                <HiOutlineUserGroup/>&nbsp;&nbsp;Customers
            </NavLink>
            </MenuItem>,
            <MenuItem key="ytHelper">
            <NavLink to = "/ythelper/dashboard">
                <AiOutlineYoutube/>&nbsp;&nbsp;YouTube Helper
            </NavLink>
            </MenuItem>,
            <MenuItem key="dueCards">
                <NavLink to="/dueCards">
                    <BiCard />&nbsp;&nbsp;Due Cards
                </NavLink>
            </MenuItem>,
            <MenuItem key="exportCards">
                <NavLink to="/exportCards">
                    <BiExport />&nbsp;&nbsp;Export Cards
                </NavLink>
            </MenuItem>,
            <MenuItem key="videosList">
            <NavLink to="/videosList">
                <BiListPlus/>&nbsp;&nbsp;Videos List
            </NavLink>
             </MenuItem>,
            <MenuItem key="billingCycle">
            <NavLink to="/billingCycle">
            <FiRepeat />&nbsp;&nbsp;Portal Billing Cycle
            </NavLink>
            </MenuItem>,
            <MenuItem key="portalManagement">
            <NavLink to="/portalManagement">
            <FiSettings />&nbsp;&nbsp;Portal Management
            </NavLink>
            </MenuItem>,
            <MenuItem key="inbox">
                <NavLink to="/inbox">
                    <BiMessageAlt />&nbsp;&nbsp;Support&nbsp;
                    {
                        unSeenMessages > 0 &&
                        <span className="unseenMessagesCount">
                            {unSeenMessages}
                        </span>
                    }
                </NavLink>
            </MenuItem>,
            <MenuItem key="dashboard">
            <NavLink to="/dashboard">
                {/* <FontAwesomeIcon icon="chart-line"/> */}
                <AiOutlineDashboard/>&nbsp;&nbsp;Dashboard
            </NavLink>
            </MenuItem>,
            <MenuItem key="archived">
            <NavLink to="/cards/archive">
                {/* <FontAwesomeIcon icon="archive"/> */}
                <RiArchiveDrawerLine/>&nbsp;&nbsp;Archived
            </NavLink>
            </MenuItem>,
            <MenuItem key="rating">
                <NavLink to="/rating">
                    <BiStar />&nbsp;&nbsp;Rating
                </NavLink>
            </MenuItem>,
            <MenuItem key="AIToolbox">
                <NavLink to="/AIToolbox">
                    <AiOutlineRobot />&nbsp;&nbsp;AI Toolbox
                </NavLink>
            </MenuItem>,
        ];
    }

    function teamLeadHeaderLinks() {
        return [
            <MenuItem key="home">
                <NavLink to="/">
                    <BiHomeAlt/>&nbsp;&nbsp;Home
                </NavLink>
            </MenuItem>,
            <MenuItem key="upload">
            <NavLink to="/upload">
                <Icon left style = {{ marginRight : "0px" }} >upload</Icon>Upload
            </NavLink>
            </MenuItem>,
            <MenuItem key="ytHelper"><NavLink to = "/ythelper/dashboard">
                <FontAwesomeIcon icon = "user"/>&nbsp;&nbsp;YouTube Helper
            </NavLink> </MenuItem>,
            <MenuItem key="users"> <NavLink to="/users">
                <FontAwesomeIcon icon="users"/>&nbsp;&nbsp;My Team
            </NavLink></MenuItem>,
            <MenuItem key="customers"> <NavLink to="/customers">
                <FontAwesomeIcon icon="users"/>&nbsp;&nbsp;My Customers
            </NavLink></MenuItem>,
            <MenuItem key="dueCards">
                <NavLink to="/dueCards">
                    <BiCard />&nbsp;&nbsp;Due Cards
                </NavLink>
            </MenuItem>,
            <MenuItem key="inbox">
                <NavLink to="/inbox">
                    <BiMessageAlt />&nbsp;&nbsp;Support&nbsp;
                    {
                        unSeenMessages > 0 &&
                        <span className="unseenMessagesCount">
                            {unSeenMessages}
                        </span>
                    }
                </NavLink>
            </MenuItem>,
            <MenuItem key="dashboard">
                <NavLink to="/dashboard">
                    <AiOutlineDashboard/>&nbsp;&nbsp;Dashboard
                </NavLink>
            </MenuItem>,
                <MenuItem key="archived">
                    <NavLink to="/cards/archive">
                        {/* <FontAwesomeIcon icon="archive"/> */}
                        <RiArchiveDrawerLine/>&nbsp;&nbsp;Archived
                    </NavLink>
                </MenuItem>,
        ];
    }

    function qaHeaderLinks() {
        return [
            <MenuItem key="home">
                <NavLink to="/">
                    <BiHomeAlt/>&nbsp;&nbsp;Home
                </NavLink>
            </MenuItem>,
            <MenuItem key="upload">
                <NavLink to="/upload">
                    <Icon left style = {{ marginRight : "0px" }} >upload</Icon>Upload
                </NavLink>
            </MenuItem>,
            <MenuItem key="ytHelper"><NavLink to = "/ythelper/dashboard">
                <FontAwesomeIcon icon = "user"/>&nbsp;&nbsp;YouTube Helper
            </NavLink></MenuItem>,
            <MenuItem key="customers"> <NavLink to="/customers">
                <FontAwesomeIcon icon="users"/>&nbsp;&nbsp;My Customers
            </NavLink>
            </MenuItem>,
            <MenuItem key="inbox">
                <NavLink to="/inbox">
                    <BiMessageAlt />&nbsp;&nbsp;Support&nbsp;
                    {
                        unSeenMessages > 0 &&
                        <span className="unseenMessagesCount">
                            {unSeenMessages}
                        </span>
                    }
                </NavLink>
            </MenuItem>,
            <MenuItem key="dueCards">
                <NavLink to="/dueCards">
                    <BiCard />&nbsp;&nbsp;Due Cards
                </NavLink>
            </MenuItem>,
        ];
    }

    function customerHeaderLinks() {
        return [
            <MenuItem key="home">
                <NavLink to="/">
                    <BiHomeAlt/>&nbsp;&nbsp;Home
                </NavLink>
            </MenuItem>,
            <MenuItem key="dashboard">
                <NavLink to="/dashboard">
                    <AiOutlineDashboard/>&nbsp;&nbsp;Dashboard
                </NavLink>
            </MenuItem>,
            <MenuItem key="inbox">
                <NavLink to="/inbox">
                    <BiMessageAlt />&nbsp;&nbsp;Support
                </NavLink>
            </MenuItem>,
            <MenuItem key="AIToolbox">
                <NavLink to="/AIToolbox">
                    <AiOutlineRobot />&nbsp;&nbsp;AI Toolbox
                </NavLink>
            </MenuItem>,
            // if customer have assigned yt helper then only show yt helper assigned card tab
            props.auth.loggedInUser.has_youtube_helper ?
                (<MenuItem key="ytHelper"><NavLink to = "/ythelper/dashboard">
                    <FontAwesomeIcon icon = "user"/>&nbsp;&nbsp;YouTube Helper
                </NavLink> </MenuItem>):null,
        ];
    }
    
    return auth?.loggedIn && <ProSidebar 
        collapsed = {toggled}
    >
    
    <SidebarHeader>
        <a className={`brand-logo ${!(subDomainData?.profile_logo && subDomainData?.sidebar_logo) && "logoWrapper"}` } href={parentId !== '0' ? "/" : undefined}>
            {subDomainData?.profile_logo ? <img src={subDomainData?.profile_logo} alt="logo" className="avatar hide-on-small-only"/> : null}
            {
                subDomainData?.sidebar_logo && (subDomainData.name !== 'acceleratusmedia') && <div style={{ paddingLeft: '16px' }}>
                <img src={subDomainData?.sidebar_logo} alt="Videoportal" className="vidchops-logo"/>
            </div>
            }
        </a>
        <Button className="sidebar-toggle" onClick={()=>{
            if(toggled)
            {
                setToggled(false);
            }
            else
            {
                setToggled(true);
            }
        }} ><span className="bars first"></span>
            <span className="bars second"></span>
            <span className="bars third"></span>
        </Button>
    </SidebarHeader>
    <SidebarContent>
    <Menu iconShape="square">
        { userTypeOptions(auth?.loggedInUser) }
    </Menu>
    </SidebarContent>
    <SidebarFooter>
      {/**
       *  You can add a footer for the sidebar ex: copyright
       */}
    </SidebarFooter>
  </ProSidebar>;
   
});

function mapStateToProps({auth, subDomain, inboxSeenMessages}) {
    return {auth, subDomain, inboxSeenMessages};
}
